import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";

export function DecimalValidator(): ValidatorFn {
    return (control: AbstractControl): null | ValidationErrors => {
        if (control.value && control.value.toString().split(".").length - 1 > 1) {
            return { "wrongNumberFormat": true };
        }
        return null;
    }
}